var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoGlobalColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 139.54,
    height: 36.055,
    viewBox: "0 0 139.54 36.055",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_9",
    "data-name": "Rect\\xE1ngulo 9",
    width: 117.719,
    height: 32.227,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-logo"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 139.54,
    height: 36.055
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    clipPath: "url(#clip-logo)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1979",
    "data-name": "Grupo 1979",
    transform: "translate(4.227 -25.278)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1975",
    "data-name": "Grupo 1975",
    transform: "translate(6.773 27.278)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1974",
    "data-name": "Grupo 1974",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_140",
    "data-name": "Trazado 140",
    d: "M71.584,31.976c-.627.992-1.24,1.992-1.882,2.973a4.461,4.461,0,0,1-7.828-4.2,27.259,27.259,0,0,1,1.658-2.962q4.487-7.428,8.993-14.844c.647-1.069,1.225-2.181,1.888-3.24A4.514,4.514,0,0,1,79.825,7.8a4.386,4.386,0,0,1,2.91,4.7,5.793,5.793,0,0,1-.748,2.066c-1.981,3.369-4.017,6.705-6.03,10.056q-2.2,3.668-4.4,7.344l.022.014",
    transform: "translate(-50.726 -6.208)",
    fill: "#00af9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_141",
    "data-name": "Trazado 141",
    d: "M15.248,71.567c1.132,1.132,2.231,2.3,3.4,3.389a4.695,4.695,0,0,1-6.578,6.7C10.364,80.056,8.692,78.412,7,76.79Q4.3,74.195,1.586,71.6a4.642,4.642,0,0,1-.864-5.968,4.644,4.644,0,0,1,7.186-.973c2.169,2.025,4.3,4.1,6.44,6.148.282.27.553.552.829.828l.07-.071",
    transform: "translate(0 -52.293)",
    fill: "#186485"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_142",
    "data-name": "Trazado 142",
    d: "M240.631,12.561q.076.891.076,1.475a8.73,8.73,0,0,1-2.442,6.333,8.272,8.272,0,0,1-6.2,2.517,8.839,8.839,0,0,1-6.434-2.568,8.52,8.52,0,0,1-2.62-6.333,8.575,8.575,0,0,1,2.594-6.32,8.668,8.668,0,0,1,6.358-2.582,9.757,9.757,0,0,1,5.062,1.323,7.038,7.038,0,0,1,3.128,3.815l-3.1,1.094a5.307,5.307,0,0,0-5.086-2.976,5.17,5.17,0,0,0-3.865,1.628,5.549,5.549,0,0,0-1.577,4.018,5.559,5.559,0,0,0,5.646,5.671,5.266,5.266,0,0,0,3.307-1.055,4.942,4.942,0,0,0,1.806-2.887H231.3V12.561Z",
    transform: "translate(-183.998 -4.194)",
    fill: "#07274a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_7",
    "data-name": "Rect\\xE1ngulo 7",
    width: 3.357,
    height: 18.641,
    transform: "translate(59.506 0.001)",
    fill: "#07274a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_143",
    "data-name": "Trazado 143",
    d: "M385.677,32.255a6.275,6.275,0,0,1,2,4.795,6.272,6.272,0,0,1-2,4.793,6.829,6.829,0,0,1-4.845,1.869,6.939,6.939,0,0,1-4.909-1.869,6.258,6.258,0,0,1-2.009-4.793,6.261,6.261,0,0,1,2.009-4.795,6.945,6.945,0,0,1,4.909-1.869,6.834,6.834,0,0,1,4.845,1.869m-2.353,7.528a3.964,3.964,0,0,0,0-5.469,3.493,3.493,0,0,0-2.493-1.055,3.79,3.79,0,0,0,0,7.579,3.493,3.493,0,0,0,2.493-1.055",
    transform: "translate(-308.509 -25.071)",
    fill: "#07274a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_144",
    "data-name": "Trazado 144",
    d: "M479.026,7.16a6.629,6.629,0,0,1,1.87,4.819,6.613,6.613,0,0,1-1.857,4.806,5.9,5.9,0,0,1-4.375,1.908,6.469,6.469,0,0,1-4.2-1.374v.993h-3.357V0h3.357V6.639a6.33,6.33,0,0,1,4.2-1.4,5.9,5.9,0,0,1,4.362,1.921m-2.39,7.579a3.785,3.785,0,0,0,1-2.76,3.831,3.831,0,0,0-1-2.773,3.4,3.4,0,0,0-2.556-1.042,3.5,3.5,0,0,0-2.517,1.068,3.671,3.671,0,0,0-1.094,2.747,3.629,3.629,0,0,0,1.094,2.734,3.515,3.515,0,0,0,2.517,1.056,3.417,3.417,0,0,0,2.556-1.03",
    transform: "translate(-385.404 -0.001)",
    fill: "#07274a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_145",
    "data-name": "Trazado 145",
    d: "M568.42,43.352h-3.357V42.03a6.477,6.477,0,0,1-4.2,1.374,5.91,5.91,0,0,1-4.375-1.908,6.612,6.612,0,0,1-1.856-4.806A6.632,6.632,0,0,1,556.5,31.87a5.9,5.9,0,0,1,4.362-1.921,6.341,6.341,0,0,1,4.2,1.4V30.331h3.357Zm-4.451-3.929a3.629,3.629,0,0,0,1.094-2.734,3.67,3.67,0,0,0-1.094-2.747,3.5,3.5,0,0,0-2.517-1.068,3.394,3.394,0,0,0-2.556,1.042,3.826,3.826,0,0,0-1.006,2.773,3.782,3.782,0,0,0,1.006,2.76,3.419,3.419,0,0,0,2.556,1.029,3.521,3.521,0,0,0,2.517-1.055",
    transform: "translate(-457.618 -24.71)",
    fill: "#07274a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_8",
    "data-name": "Rect\\xE1ngulo 8",
    width: 3.357,
    height: 18.641,
    transform: "translate(114.362 0.001)",
    fill: "#07274a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_146",
    "data-name": "Trazado 146",
    d: "M337.8,146.093h2.526a2.1,2.1,0,1,1,0,4.194H338.52v2.478H337.8Zm2.526,3.527a1.43,1.43,0,1,0,0-2.86H338.52v2.86Z",
    transform: "translate(-278.716 -120.538)",
    fill: "#07274a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_147",
    "data-name": "Trazado 147",
    d: "M386.624,146.093h.667l2.764,6.673h-.763l-.762-1.859h-3.146l-.763,1.859h-.762Zm1.62,4.146-1.287-3.146-1.287,3.146Z",
    transform: "translate(-316.715 -120.538)",
    fill: "#07274a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_148",
    "data-name": "Trazado 148",
    d: "M441.112,150.43l-2.478-4.337h.81l2,3.575h.048l2-3.575h.81l-2.478,4.337v2.335h-.715Z",
    transform: "translate(-361.908 -120.538)",
    fill: "#07274a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_149",
    "data-name": "Trazado 149",
    d: "M490.41,146.093h.62l2.764,3.622,2.764-3.622h.62v6.673h-.715v-5.433l-2.669,3.527-2.669-3.527v5.433h-.715Z",
    transform: "translate(-404.628 -120.539)",
    fill: "#07274a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_150",
    "data-name": "Trazado 150",
    d: "M548.453,146.093h4.575v.667h-3.86v2.192h3.1v.667h-3.1V152.1h3.956v.667h-4.671Z",
    transform: "translate(-452.518 -120.539)",
    fill: "#07274a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_151",
    "data-name": "Trazado 151",
    d: "M594.508,146.093h.62l4.1,5.386v-5.386h.715v6.673h-.62l-4.1-5.386v5.386h-.715Z",
    transform: "translate(-490.517 -120.539)",
    fill: "#07274a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_152",
    "data-name": "Trazado 152",
    d: "M647.02,146.761h-2.1v-.667h4.909v.667h-2.1v6.005h-.715Z",
    transform: "translate(-532.113 -120.539)",
    fill: "#07274a"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGlobalColor);
export default __webpack_public_path__ + "static/media/logo_global_color.3fac1e41aa31ee7ee4778efd47fcaf78.svg";
export { ForwardRef as ReactComponent };